<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="8"
        :md="12"
        :sm="12"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('User.reportCusType')}}</div>
        <el-select
          :placeholder="$t('please_choose')"
          v-model="customerType"
          style="width: 100%"
          @change="toQuery"
          clearable
        >
          <el-option
            v-for="(item,index) in customerTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="8"
        :sm="12"
        :md="12"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('Operation_method')}}</div>
<!--        样式需要改-->
        <el-select
          :placeholder="$t('User.accType')"
          v-model="way"
          :style="prefixStyle"
          class="short-select"
          @change="wayChange"
          clearable
        >
          <el-option
            v-for="(item,index) in wayList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <!--具体的出入金方式-->
        <el-select
          v-model="type"
          :placeholder="$t('Way')"
          :style="backHendStyle"
          class="long-select"
          @change="toQuery"
          clearable
        >
          <el-option
            v-for="(item,index) in filterTypeList"
            :key="index"
            :label="item.desc"
            :value="item.payType"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="8"
        :md="12"
        :sm="12"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('processing_time')}}</div>
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd HH-mm-ss"
          :range-separator="phFileter('root.dateTo')"
          :start-placeholder="phFileter('root.startDate')"
          :end-placeholder="phFileter('root.endDate')"
          @change="toQuery"
        >
        </el-date-picker>
        <select-date-duration
          class="header-sub-item"
          v-model="date"
        ></select-date-duration>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "queryHeader",
  props: {
    typeList: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    let _this = this;
    return {
      customerType: '',
      customerTypeList: [
        {label: _this.$t('direct'),value: 0},
        {label: _this.$t('indirect'),value: 1},
      ],
      way: '',
      wayList: [
        {label: _this.$t('Trade.depo'),value: 1},
        {label: _this.$t('User.out'),value: 2},
      ],
      type: '',
      date: [], // 时间
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
    filterTypeList() {
      if(!this.typeList.length){
        return []
      }else {
        let enterList = this.typeList.filter((item) => {
          return item.type == 1;
        });
        let outerList = this.typeList.filter((item) => {
          return item.type == 2;
        });
        if(this.way == 1){
          return enterList[0].payTypeList;
        }else if(this.way == 2){
          return outerList[0].payTypeList;
        }
      }
    },
    prefixStyle(){
      if(this.realMobile){
        return {
          width: '120px'
        }
      }else {
        return {
          width: '25%'
        }
      }
    },
    backHendStyle(){
      if(this.realMobile){
        return {
          width: 'calc(100% - 120px)'
        }
      }else {
        return {
          width: '75%'
        }
      }
    }
  },
  methods: {
    phFileter(data){
      return this.$t(data)
    },
    toQuery(){
      this.$emit('toQuery');
    },
    wayChange(){
      this.type = '';
      this.$emit('toQuery');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  /deep/ .short-select .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }
  /deep/ .long-select .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .select-date-duration {
    width: 100%;
  }
}
</style>
